// extracted by mini-css-extract-plugin
export default {"accountSummaryTitle":"HeaderSubHeader_accountSummaryTitle__PQH2H","accountSummarySubTitle":"HeaderSubHeader_accountSummarySubTitle__ei9uL"};